import { breakpoints } from '@ui/css';
import { Richtext } from '@ui/kit';
import { colors } from '@ui/kit/design-tokens';
import { useIsTouchDevice } from '@utils/common';
import { freetextInput } from '@utils/component-framework';
import { useMatchBreakpoint } from '@utils/react';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { input } from './input.richtext.style.js';
import { jsx } from 'react/jsx-runtime';

const pencilSvg = `<svg viewBox="0 0 10.32 10.32" xmlns="http://www.w3.org/2000/svg" height="18" fill="none" stroke="${colors.gray.sim65()}" stroke-linecap="round" stroke-linejoin="round"><path d="m3.27 9.33-2.77.5.48-2.78 6.2-6.2a.92.92 0 0 1 1.3 0l.98.98a.92.92 0 0 1 0 1.31z" /></svg>`;
function RichtextInput(props) {
  const isMobile = useMatchBreakpoint(breakpoints.tablet.andDown(), {
    immediate: true
  });
  const isTouchDevice = useIsTouchDevice({
    immediate: true
  });
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => freetextInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.task.id])
  });
  const onChange = nextContent => {
    update(props.taskEntryKey, props.task.id, {
      type: "freetext",
      richtext: nextContent
    });
  };
  return /*#__PURE__*/jsx(Richtext, {
    className: input,
    placeholderText: isMobile && isTouchDevice ? "Skriv svar" : pencilSvg,
    initialValue: inputEntry?.richtext,
    onChange: onChange
  });
}

export { RichtextInput };
//# sourceMappingURL=input.richtext.js.map
